<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-start">
      <div>
        <Breadcrumbs
          headline="Quản lý Kiểm hàng nhập"
          :link="[{ text: 'Danh sách kiểm hàng nhập', href: '/audit-product' }]"
        />
      </div>
    </div>
    <FilterAuditProduct />
    <v-card outlined class="mx-4 mb-6 elevation-0">
      <TableListAuditProduct />
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import FilterAuditProduct from '../../modules/audit-product/FilterAuditProduct.vue'
import TableListAuditProduct from '../../modules/audit-product/TableListAuditProduct.vue'
export default {
  components: {
    Breadcrumbs,
    FilterAuditProduct,
    TableListAuditProduct
  }
}
</script>
